import type { BaseTranslation } from "../i18n-types";

const ee = {
	WELCOME_LONG: "Tere tulemast Unicorn Digital Courtroom",
	WELCOME: "Tere tulemast, {name:string}!",
	JOIN_ROOM_DESCRIPTION: "Liitu alltoodud ruumiga või loo oma ruum!",
	NO_ROOM: "Ei näe otsitavat ruumi? Loo oma ruum.",
	CREATE_ROOM: "Loo ruum",
	ROOM: "Ruum",
	ACCESSIBILITY_SETTINGS: "Ligipääsetavuse seaded",
	ACCESSIBILITY_SETTINGS_DESCRIPTION: "Muuda ligipääsetavuse seadeid siin",
	CONTRAST: "Kontrast",
	SELECT_DISPLAY_NAME: "Palun sisesta kuvatav nimi, mida soovid kasutada",
	SOMETHING_WENT_WRONG: "Ups! Midagi läks valesti.",
	GO_BACK: "Mine tagasi",
	GO_BACK_TO_ROOM: "Tagasi ruumi",
	EXPAND: "Laienda",
	EXPORT: "Ekspordi",
	JOIN_ROOM: "Liitu ruumiga",
	ROOM_ENDED_TITLE: "Ruum on suletud",
	ROOM_ENDED_DESCRIPTION: "Ruum on lõppenud, sind suunatakse avalehele",
	RENAME_FAILED: "Ümbernimetamine ebaõnnestus.",
	TRANSCRIPT_DISCLAIMER:
		"Transkriptsioon põhineb tuvastatud kõnelejatel. Tuvastamiseks peab rääkima rohkem kui 7 sekundit.",
	CHANGE_SPEAKER_TITLE: "Muuda kõnelejat",
	CHANGE_SPEAKER_DESCRIPTION: "muuda kõneleja nime ja värvi siin",
	PREVIEW_MESSAGE: "See on eelvaate sõnum",
	COLOR: "Värv",
	NAME: "Nimi",
	CANCEL: "Tühista",
	LANGUAGE: "Keel",
	SAVE: "Salvesta",
	ROOM_ID: "Ruumi ID",
	ROOM_ID_FORM_PLACEHOLDER: "Sisesta ruumi ID liitumiseks",
	ROOM_ID_FORM_REQUIRED: "Ruumi ID on liitumiseks vajalik",
	ROOM_ID_FORM_MIN_LENGTH: "Ruumi ID peab olema 17 tähemärki",
	LOGIN: "Logi sisse",
	ROOM_COL: "Ruum:",
	LANGUAGE_COL: "Keel",
	END_ROOM: "Lõpeta ruum",
	JOIN_NOW: "Liitu kohe",
	LOGIN_FORM: {
		TOAST_TITLE: "Sisse logitud!",
		TOAST_DESCRIPTION: "Nüüd saad luua/liituda ruumiga!",
		DISPLAY_NAME: "Kuvatav nimi",
		DISPLAY_NAME_FORM_PLACEHOLDER: "Sisesta kuvanimi",
		DISPLAY_NAME_FORM_SHORT: "Kuvatav nimi peab olema vähemalt 3 tähemärki",
		DISPLAY_NAME_FORM_LONG: "Kuvatav nimi võib olla maksimaalselt 32 tähemärki",
		DISPLAY_NAME_FORM_REQUIRED: "Kuvatav nimi on kohustuslik",
	},
	PROFILE_FORM: {
		TITLE: "Lõpeta oma profiil",
		DESCRIPTION: "Palun sisesta oma kuvatav nimi alustamiseks",
		TOAST_SUCCESS_TITLE: "Profiil uuendatud!",
		TOAST_SUCCESS_DESCRIPTION: "Sinu profiil on edukalt salvestatud.",
		TOAST_ERROR_TITLE: "Uuendamine ebaõnnestus",
		TOAST_ERROR_DESCRIPTION:
			"Profiili uuendamine ebaõnnestus. Palun proovi uuesti.",
		SUBMIT_BUTTON: "Salvesta profiil",
	},
	DIARIZATION: {
		UNDETECTED: "Kpɔmahɔ̃",
		ACCURACY: "Täpsus",
		ID: "ID",
		LEXICAL: "Lexical",
		ITN: "ITN",
		MASKED_ITN: "ITN märgistatud",
		LANGUAGE: "Keel",
		ORIGINAL_TEXT: "Algne tekst",
		SPEAKER: "Kõneleja",
	},
	NO_ROOMS_LIST: "Ups, ruume ei leitud.",
	SEARCH_FOR_A_ROOM: "Otsi ruumi",
	AUTH_ERROR_DESCRIPTION:
		"Autentimisel tekkis probleem. Palun värskenda lehte.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "Kustuta ruum",
		DESCRIPTION: "Kas oled kindel, et soovid selle ruumi kustutada?",
		CANCEL: "Tühista",
		DELETE: "Kustuta",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "Tuba loodud",
		DESCRIPTION: "Sinu tuba on valmis liitumiseks.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION: "Määra oma ruumile nimi, et teised seda näeksid.",
		NAME_LABEL: "Ruumi nimi",
		NAME_PLACEHOLDER: "Sisesta ruumi nimi",
		LANGUAGE: "Keel",
		LANGUAGE_PLACEHOLDER: "Vali keel",
		AUTO_DETECT: "Automaatne tuvastus",
		ENGLISH_US: "Inglise (Ameerika Ühendriigid)",
		ENGLISH_IN: "Inglise keel (India)",
		ARABIC_KSA: "Araabia (Saudi Araabia)",
		SPANISH_CR: "Hispaania (Costa Rica)",
		CATALAN_ES: "Katalaani (Hispaania)",
		PORTUGUESE_PT: "Portugali (Portugal)",
		PORTUGUESE_BR: "Portugali (Brasiilia)",
		ESTONIAN_EE: "Eesti (Eesti)",
		RUSSIAN_RU: "Vene (Venemaa)",
		MALTESE_MT: "Malta keel (Malta)",
		FILIPINO_PH: "Filipiini (Filipiinid)",
		SPANISH_MX: "Hispaania (Mehhiko)",
		CHINESE_CN: "Hiina (Mandariini)",
		VIETNAMESE_VN: "Vietnami (Vietnam)",
		KOREAN_KR: "Korea (Korea)",
		HINDI_IN: "Hindi (India)",
		PERSIAN_IR: "Pärsia (Iraan)",
		LANGUAGE_DESCRIPTION: "Vali ruumi keel, ruumi keelt ei saa hiljem muuta.",

		INCPERSONDEFAULT: "Tamm,Jaan",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "Järgnev sobivuskuulamine",
		SCHEDULEDEFAULT: "28.11.2023, 10:30 EET",
		ADVANCED: "Täpsemad seaded",
		INCARCERATED_PERSON_PLACEHOLDER: "Sisesta oma nimi",
		CDC_PLACEHOLDER: "Sisesta CDC number",
		HEARING_TYPE_PLACEHOLDER: "Sisesta kuulamise tüüp",
		INCARCERATED_PERSON: "Kinnipeetav isik",
		CDC: "CDC",
		HEARING_TYPE: "Kuulamise tüüp",
		SCHEDULE: "Ajakava",
		PICKDATE: "Vali kuupäev",
		STEP_DETAILS: "Üksikasjad",
		STEP_MODEL: "Mudel",
		CONTINUE: "Jätka",
		BACK: "Tagasi",
		MODEL_TITLE: "Transkriptsiooni mudel",
		MODEL_DESCRIPTION: "Choose the model everyone in this room starts with. You can lock it so participants keep it.",
		LOCK_MODEL: "Lock model for everyone",
		LOCK_MODEL_DESC: "Participants cannot change the transcription model in this room.",
		HOURS: "Tunnid",
		MINUTES: "Minutid",
		SECONDS: "Sekundid",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "Eksportimine ebaõnnestus",
		TOAST_FAILED_DESCRIPTION: "Tühja transkriptsiooni ei saa eksportida.",
		DOWNLOAD: "Laadi alla",
		DOWNLOAD_DESCRIPTION: "Vali ekspordi formaat ja luba lisavalikud.",
		SELECT_FORMAT: "Vali formaat",
		SELECT_FORMAT_PLACEHOLDER: "Vali ekspordi formaat",
		DOCUMENT: "Dokument (.pdf)",
		SPREADSHEET: "Arvutustabel (.csv)",
		AUDIO: "Heli (.mp3)",
		DOCX: "Wordi dokument (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "Tõlge",
		BODY: "Kas soovid rakendada seda muudatust kõigile selle kasutaja transkriptsioonidele?",
		APPLY_TO_SPEAKER: "Rakenda ainult sellele kasutajale",
		APPLY_ONCE: "Rakenda ainult siin",
		APPLY_TO_ALL: "Rakenda kõigile kasutajatele",

		TRANSLATE: "Tõlgi",
	},
	GUEST_FORM: {
		TITLE: "Külalise juurdepääs",
		DESCRIPTION:
			"Sisesta oma e-posti aadress, et saada turvaline sisselogimislink",
		EMAIL_LABEL: "E-posti aadress",
		EMAIL_PLACEHOLDER: "Sisesta e-posti aadress",
		EMAIL_REQUIRED: "E-posti aadress on kohustuslik",
		EMAIL_INVALID: "Palun sisesta kehtiv e-posti aadress",
		SEND_LINK: "Saada sisselogimislink",
		SUCCESS_TITLE: "Kontrolli oma e-posti",
		SUCCESS_DESCRIPTION:
			"Saatsime sisselogimislingi sinu e-posti aadressile. Kliki lingil, et ruumi siseneda.",
		ERROR_TITLE: "Midagi läks valesti",
		ERROR_DESCRIPTION:
			"Sisselogimislingi saatmine ebaõnnestus. Palun proovi uuesti.",
		CANCEL: "Tühista",
	},
	START_DATE_TIME: "Alguse kuupäev ja kellaaeg",
	END_DATE_TIME: "Lõpu kuupäev ja kellaaeg",
	REVERT_TO_ORIGINAL: "Taasta algne",
	SELECTED_LANGUAGE: "Valitud keel",
	TRANSLATION_INFO: "Mõned transkriptsioonid on tõlgitud originaalist.",
	INVITE_GUEST: "Kutsu külaline",
	INVITE_GUEST_DESCRIPTION:
		"Kutsu külaline toas, sisestades nende nime ja e-posti aadressi",
	CREATED_BY: "Loomine",
	VIEW_ALL: "Vaata kõiki",
	LOBBY: {
		LOBBY: "Fuajee",
		WAITING_IN_LOBBY: "{name} ootab fuajees",
		USERS_WAITING_IN_LOBBY: "Halda kasutajaid, kes hetkel fuajees ootavad.",
		SEND_INVITE: "Saada kutse",
		ADMIT: "Luba sisse",
		REJECT: "Keeldu",
		NO_PARTICIPANTS: "Fuajees ei ole osalejaid.",
	},
	CLOSE: "Sulge",
	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"Kogege reaalajas transkriptsiooni koos edasijõudnud kõnelejate tuvastamise tehnoloogiaga. Suurepärane koosolekuteks, intervjuudeks ja konverentsideks.",
		CAROUSEL_STORY_2:
			"Kõrge kontrastsuse režiim, kohandatavad fondid ja mitmekeelne tugi tagavad, et kõik saavad meie platvormi tõhusalt kasutada.",
		CAROUSEL_STORY_3:
			"Teie vestlused on kaitstud ettevõtte taseme turvalisusega. Liituge tuhandete spetsialistidega, kes usaldavad uTranscribe'i.",
		CAROUSEL_STORY_4:
			"Valige allpool oma identifitseerimismeetod ja alustage transkribeerimist sekundites. Keerukas seadistamine pole vajalik.",
		CDCR_TEAM_TITLE: "Tech Unicorn meeskond",
		CDCR_TEAM_SUBTITLE: "Kinnitatud liige",
		OR_CONTINUE_WITH: "või jätka",
		GUEST_ACCESS_SUBTITLE: "Pole liige? Liitu oma koosoleku ID-ga",
		WELCOME_TO: "Tere tulemast",
		CHOOSE_IDENTIFICATION: "Palun valige oma identifitseerimismeetod",
		NEED_HELP: "Vajad abi? Võta ühendust meie tugiteenusega.",
		CALL_SUPPORT: "Helista 1-877-742-2135",
		EMAIL_SUPPORT: "Kirjuta meile support@courtroom.tech",
	},
	SIZES: "Suurused",
	DIAGNOSTICS: "Diagnostika",
	ROOM_BACKGROUND: "Ruumitaust",
	NOT_AVAILABLE: "Puudub",
	UNRECOGNIZED_SPEECH: "Tundmatu kõne",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"See transkript ei ole tuvastatud. Palun kontrolli helifaili ja proovi uuesti.",
	UNDETECTED: "Kpɔmahɔ̃",
	MICROPHONE_QUALITY_WARNING:
		"Palun kontrolli mikrofoni kvaliteeti täpsuse parandamiseks või reguleeri mikrofoni kaugust",
	LOW_ACCURACY_WARNING: "Täpsus madal",
	UNKNOWN: "Tundmatu",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "Transkriptsiooni seaded",
		GENERAL: "Üldine",
		GENERAL_HINT: "Teema, font ja keel",
		MODE_HINT: "Transkriptsiooni käitumine",
		MODEL_HINT: "AI töötlusmootor",
		MODE: "Režiim",
		LIVE_TRANSCRIPTION: "Reaalajas transkriptsioon",
		SEGMENTED_TRANSCRIPTION: "Jaotatud transkriptsioon",
		FINAL_TRANSCRIPTION: "Lõplik transkriptsioon",
		LIVE_DESC:
			"Vaadake oma kõne reaalajas transkriptsiooni eraldi paneelis rääkides. Peamine paneel näitab kõigi kõnelejate lõplikku transkriptsiooni.",
		SEGMENTED_DESC:
			"Kuvab ajutise jaotatud transkriptsiooni reaalajas, mis värskendatakse automaatselt lõplikuks versiooniks.",
		FINAL_DESC:
			"Kuvab ainult lõpliku transkriptsiooni peamises paneelis. Reaalajas transkriptsiooni ei kuvata.",
		SPEED_VALUE: "Kiirus: {value}x",
		SPEED: "Kiirus",
		FONT_TEST:
			"UTranscribe muudab revolutsiooniliselt viisi, kuidas me kõnet salvestame ja mõistame.",
		FONT_SIZE: "Fondi suurus",
		SPEED_DESC: "Transkriptsiooni kiirus ja viivitus",
		DELAY_DESC: "{speed:number}x kiirus = {delay:number} sekundi viivitus",
		MODEL: "Mudel",
		MODEL_TITLE: "Transkriptsiooni mudel",
		MODEL_DESC: "Valige AI mudel, mida kasutatakse teie transkriptsioonide töötlemiseks.",
		MODEL_DEFAULT: "Vaikimisi",
		MODEL_WHISPER: "Allicorn Model 1",
		MODEL_GPT4O: "GPT-4o",
		MODEL_GPT4O_MINI: "GPT-4o Mini",
		MODEL_FAST: "Allicorn Model 2",
		MODEL_DEFAULT_DESC:
			"Microsofti kõnelejate eristamise teenus kiire töötlemise ja usaldusväärse täpsusega enamiku kasutusjuhtude jaoks.",
		MODEL_DEFAULT_SHORT_DESC:
			"Kiire ja usaldusväärne kõnelejate eristamine enamiku kasutusjuhtude jaoks.",
		MODEL_WHISPER_DESC:
			"Allicorn Model 1 suurema täpsusega keeruliste helikeskkondade ja spetsiifilise sõnavara jaoks.",
		MODEL_WHISPER_SHORT_DESC:
			"Kõrge täpsus keerulise heli ja spetsiifiliste terminite jaoks.",
		MODEL_GPT4O_DESC:
			"OpenAI GPT-4o transkriptsiooni mudel kõrgeima täpsuse ja keele mõistmisega.",
		MODEL_GPT4O_SHORT_DESC:
			"Kõrgeim transkriptsiooni täpsus ja keele mõistmine.",
		MODEL_GPT4O_MINI_DESC:
			"OpenAI GPT-4o Mini transkriptsiooni mudel, mis tasakaalustab täpsust ja kiirust.",
		MODEL_GPT4O_MINI_SHORT_DESC:
			"Tasakaalustatud transkriptsiooni täpsus ja kiirus.",
		MODEL_FAST_DESC:
			"Allicorn Model 2 transkriptsiooni teenus, mis on optimeeritud madala viivitusega töötlemiseks.",
		MODEL_FAST_SHORT_DESC:
			"Madala viivitusega transkriptsiooni töötlemine.",
		MODEL_ENHANCED: "Täiustatud",
		MODEL_PREMIUM: "Premium",
		MODEL_BETA: "Beta",
		MODEL_BETA_TOOLTIP: "This feature is currently in beta. Expect occasional inaccuracies as we continue fine-tuning.",
		MODEL_LOCKED: "Model locked",
		MODEL_LOCKED_DESC: "The host fixed the transcription model when this room was created.",
		MODEL_LOCKED_HINT: "Locked by the room host.",
		DOMAIN_MATH_UNAVAILABLE: "Not available for the selected model.",
		DOMAIN_MATH: "Matemaatika optimeeritud",
		DOMAIN_MATH_DESC:
			"Kuvab suulised matemaatilised sümbolid ja võrrandid tavalise teksti asemel tegeliku matemaatilise tähistusena.",
	},
	NO_AUDIO: "Heli ei tuvastatud",
	NO_AUDIO_DESC:
		"Sinu mikrofon on sisse lülitatud, kuid heli ei tuvastata. Kontrolli mikrofoni seadeid või vali teine mikrofon.",
	NO_TRANSCRIPTION: "Transkriptsioone ei loodud",
	NO_TRANSCRIPTION_DESC:
		"Transkriptsioone ei genereerita. Palun värskenda lehte.",
	SCROLLING_PAUSED: "Allapoole kerimine on peatatud",
	RESUME: "Jätka",
} satisfies BaseTranslation;

export default ee;
